import Vue from "vue";
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
    ak: "Wuj1WAYu6GMyicgVZhEd9EoEbmcmbGHe"
});
